// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__cHFeM","empty":"ModalGraph_empty__1aagu"};